import { SenderSource } from '@enuan/chat__utils';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { messagesSlice } from '../reduxStore/slices/messages.slice';
import { useEnuanLocalStorage } from './useEnuanLocalStorage';
import { useDelayedIntersectEffect } from './useDelayedIntersectEffect';
import { IClientMessage } from 'src/interfaces';

/**
 * Triggers mark-as-read when the message element enters the viewport.
 * Use for message components that do not render the full Message UI (e.g. InfoMessage, ClosedMessage).
 */
export const useMessageReadEffect = (
	ref: React.RefObject<HTMLElement> | null,
	message: IClientMessage,
	getRead?: (event: 'intersect' | 'click') => boolean | undefined,
) => {
	const dispatch = useDispatch();
	const { updateStorageTimestamp } = useEnuanLocalStorage();

	const {
		client_id,
		sender,
		timestamp,
		_meta: { read: messageRead } = {},
	} = message;

	const isRead = messageRead || sender === SenderSource.USER;
	const setRead = useCallback(
		(event: 'intersect' | 'click') => {
			const shouldMarkAsRead = getRead?.(event);
			console.log('[useMessageReadEffect]', event, {
				shouldMarkAsRead,
				messageRead,
				timestamp,
				isRead,
			});
			if (shouldMarkAsRead === false || isRead) return;
			console.log('[useMessageReadEffect] Marking as read', {
				client_id,
				timestamp,
			});
			if (timestamp) updateStorageTimestamp(timestamp);
			dispatch(
				messagesSlice.actions.toggleRead({
					client_id,
					read: true,
				}),
			);
		},
		[
			client_id,
			dispatch,
			getRead,
			isRead,
			messageRead,
			timestamp,
			updateStorageTimestamp,
		],
	);

	useDelayedIntersectEffect(ref, () => setRead('intersect'));

	return setRead;
};
